import React from 'react';
import { Tabs as MantineTabs } from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import * as tabsStyles from './Tabs.module.css';

interface ITabsProps {
  activeTab: string | null;
  onTabChange?: (tab: string | null) => void;
}
export function Tabs({ activeTab, onTabChange }: ITabsProps) {
  const { width } = useViewportSize();
  const eventDetailsText = width < 420 ? "Details" : "Event Details";
  const guestBookText = width < 420 ? "Book" : "Guest Book";

  return (
    <MantineTabs defaultValue="chat" w={"100%"} color='#7fac9d' value={activeTab} onChange={onTabChange}>
      <MantineTabs.List className={tabsStyles.list}>
        <MantineTabs.Tab className={tabsStyles.tab} value="gifts" styles={{ tabLabel: { color: "white", fontWeight: "700" }}}>Gifts</MantineTabs.Tab>
        <MantineTabs.Tab className={tabsStyles.tab} value="photos" styles={{ tabLabel: { color: "white", fontWeight: "700" }}}>Photos</MantineTabs.Tab>
        <MantineTabs.Tab className={tabsStyles.tab} value="guest book" styles={{ tabLabel: { color: "white", fontWeight: "700" }}}>{guestBookText}</MantineTabs.Tab>
        <MantineTabs.Tab className={tabsStyles.tab} value="details" ml="auto" styles={{ tabLabel: { color: "white", fontWeight: "700" }}}>
          {eventDetailsText}
        </MantineTabs.Tab>
      </MantineTabs.List>
    </MantineTabs>
  );
}